import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const tracingLocationAdapter = getAdapter();

const truckPermitRulesSlice = createSlice({
  name: 'truckPermitRules',
  initialState: tracingLocationAdapter.getInitialState(),
  reducers: {
    setTruckPermitRules: (state, { payload: { truckPermitRules } }) => {
      tracingLocationAdapter.setAll(state, truckPermitRules);
    },
  },
});

const selectors = tracingLocationAdapter.getSelectors(({ truckPermitRules }) => truckPermitRules);

export const getTruckPermitRules = (state) => selectors.selectAll(state);

export const { setTruckPermitRules } = truckPermitRulesSlice.actions;

export default truckPermitRulesSlice.reducer;
